import React from "react";

const ArrowDown = () => (
    <svg width="12" height="6" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.625 0.625L6.625 6.625L12.625 0.625" stroke="#242424" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

export default ArrowDown;
